// Basic
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';

// Modules
import { MaterialModule } from '@app/material.module';

// Components
import { SnackBarGeneralErrorComponent } from './snack-bar-general-error.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    MaterialModule
  ],
  declarations: [SnackBarGeneralErrorComponent],
  exports: [SnackBarGeneralErrorComponent],
  entryComponents: [SnackBarGeneralErrorComponent]
})
export class SnackBarGeneralErrorModule { }
